import React from 'react';

const SvgSelectedLocationMarker = ({ title, ...props }) => (
  <svg viewBox="0 0 25.758 39.332" {...props}>
    {title ? <title>{title}</title> : null}
    <g data-name="Location marker">
      <g
        data-name="Ellipse 37"
        transform="translate(4.316 5.465)"
        stroke="#707070"
      >
        <circle cx={8.156} cy={8.156} stroke="none" r={8.156} />
        <circle cx={8.156} cy={8.156} fill="none" r={7.656} />
      </g>
      <path
        data-name="Path 334"
        d="M12.879 0A12.9 12.9 0 000 12.879c0 10.368 11.376 24.6 11.86 25.193l1.019 1.261 1.021-1.261c.484-.605 11.86-14.825 11.86-25.193A12.9 12.9 0 0012.879 0zm0 18.436a5.4 5.4 0 115.4-5.4 5.4 5.4 0 01-5.4 5.4z"
        fill="#3b7fc1"
      />
    </g>
  </svg>
);

export default SvgSelectedLocationMarker;
